// Shared constants and utilities used by multiple TurnoverDetail sub-components.

export const NAVY_ACTION = "#1e3a5f";
export const CORRESPONDENCE_PROMPT_CATEGORY = "correspondence";

export const STATUS_CONFIG = {
  "Contract Review":  { bg: "#f0fdf4", color: "#166534", dot: "#22c55e" },
  "Pending Number":   { bg: "#fef3c7", color: "#92400e", dot: "#f59e0b" },
  "Numbered":         { bg: "#dbeafe", color: "#1e40af", dot: "#3b82f6" },
  "Active":           { bg: "#ede9fe", color: "#5b21b6", dot: "#8b5cf6" },
  "In Progress":      { bg: "#e0f2fe", color: "#0369a1", dot: "#0ea5e9" },
  "Package Complete": { bg: "#d1fae5", color: "#065f46", dot: "#10b981" },
  "Turned Over":      { bg: "#f3f4f6", color: "#374151", dot: "#9ca3af" },
};

const ET = "America/New_York";

// Parse date-only strings (YYYY-MM-DD) as local midnight so the date never
// flips due to UTC conversion. Full datetime strings are returned as-is (JS
// handles them correctly when a Z or offset suffix is present; without one,
// the value is treated as local — acceptable since the SQL server is Eastern).
export function parseLocalDate(d) {
  if (!d) return null;
  const s = String(d);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(s + "T00:00:00");
  return new Date(s);
}

export function fmtDate(d) {
  const dt = parseLocalDate(d);
  if (!dt || isNaN(dt)) return "—";
  return dt.toLocaleDateString("en-US", { timeZone: ET, month: "short", day: "numeric", year: "numeric" });
}

export function fmtDateTime(d) {
  const dt = parseLocalDate(d);
  if (!dt || isNaN(dt)) return "—";
  return dt.toLocaleString("en-US", { timeZone: ET, month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
}

export function fmtPhone(v) {
  if (!v) return "";
  const digits = String(v).replace(/\D/g, "");
  if (digits.length === 11 && digits[0] === "1") {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return String(v);
}

export function fmtCurrency(v) {
  if (!v) return null;
  const n = parseFloat(v);
  if (isNaN(n)) return v;
  return "$" + n.toLocaleString("en-US", { maximumFractionDigits: 0 });
}

// Returns the current calendar year in Eastern time — safe even for users
// whose browser/OS clock is set to a different timezone.
export function getYear() {
  return parseInt(new Intl.DateTimeFormat("en-US", { timeZone: ET, year: "numeric" }).format(new Date()), 10);
}

// Numeric-aware sort for SummaryType values like "prefix_s1", "prefix_s10".
export function bySummaryNum(a, b) {
  const numOf = (s) => {
    const m = (s.SummaryType || "").match(/_s(\d+)$/);
    return m ? parseInt(m[1], 10) : 0;
  };
  return numOf(a) - numOf(b);
}
